import React from 'react';
import { OCMNavBar } from './OCMNavBar';
import { SubscriptionNavBar } from './SubscriptionNavBar';
import { AlertSubscriptionLevel, useSubscriptionAlert } from './useSubscriptionAlert';

type Props = {
  testID?: string;
};

export const NavSubscriptionOCM: React.FC<Props> = () => {
  const { level, expireAt } = useSubscriptionAlert();

  if (!(['ALERT', 'WARNING'] as AlertSubscriptionLevel[]).includes(level)) {
    return <OCMNavBar />;
  }

  return <SubscriptionNavBar expireAt={expireAt} level={level} />;
};
